import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import { ToggleButtonGroup, ToggleButton} from "react-bootstrap"
import moment from "moment";
import toast, { Toaster } from 'react-hot-toast';
import {Promise} from "es6-promise";
import PaymentProcess from "./PaymentProcess";


const CommandePayementMethode= (props)=>{


    const [payMod,setPayMod] = useState()
    const [cgv, setCgv] = useState(false)
    const [commande, setCommande] = useState(null)
    const [cbPaye, setcbPaye] = useState(false)


    const payModValues = [
        {"id": 1, "label": "Virement", "code": "virement", "picto": "fas fa-money-check"},
        {"id": 2, "label": "Carte Bleue", "code": "carte", "picto": "far fa-credit-card"},
        {"id": 3, "label": "Cheque", "code": "cheque", "picto": "fas fa-edit"},
    ]


    const fetchInitCommande =()=>{

        let promise = new Promise((resolve, reject )=>{
            axios.post('/Api/shop/init_commande',
                {
                    'paycode': payMod,
                    'total': props.total,
                    'products': props.products,
                    'tax': props.tax,
                    'orderAddress': props.orderAddress,
        })
                .then(result => {
                    setCommande(result.data.order)
                    props.setPaymentIntent(result.data.intent)
                    resolve("Enregistrment de votre commande réalisé")

                }).catch(err => {
                    reject("Un problème est survenu et lors de l'enregistrement de votre commande")
            })
        });
        return promise;
    }




    const handleChange = (val)=>{
            setPayMod(val)
            console.log()
    }

    const handleCommande = (val)=>{

        const successMsg = (payMod=='carte')?<b>Merci d'effectuer votre réglement pour finaliser votre commande!</b>:<b>Commande effectuée!</b>;
        if(payMod!=='carte'){
            toast.promise(
                fetchInitCommande(),
                {
                    loading: 'Enregistrement en cours...',
                    success: successMsg,
                    error: <b>Un problème est survenue et votre commande ne peu être créée</b>,
                }
            );
        }else{

        }
    }

    const renderPAyMod = ()=>{
        switch(payMod){
            case "virement":
                return (
                <div className={"border rounded border-secondary text-center p-2 my-2"}>
                    <h5 className={"font-weight-bold"}>Vous avez choisi un mode de réglement par virement</h5>
                    <p>Merci d'effectuer votre réglement au cordonnées suivantes après votre commande</p>
                    <div className={"text-dark"}>
                        <table className={"table table-borderless text-left text-dark"}>
                            <tbody>
                            <tr><td width={150}>Destinataire : </td><td className={"font-weight-bold"}>{(props.shop)?props.shop.name:''}</td></tr>
                            <tr><td>IBAN  : </td><td className={"font-weight-bold"}>{(props.shop)?props.shop.iban:''}</td></tr>
                            <tr><td>BIC : </td><td className={"font-weight-bold"}>{(props.shop)?props.shop.bic:''}</td></tr>
                            <tr><td>Commande réf: </td><td className={"font-weight-bold"}>{'uefr'+props.structure.id+moment().format('YYMMDHm')}</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <p>Une fois l'encaissement effectué vos éléments seront disponibles dans votre espace</p>
                    <button className={"btn btn-primary"} onClick={handleCommande}>Commander</button>
                </div>
                )
            case "cheque":
                return (
                    <div className={"border border-secondary text-center p-2 my-2"}>
                            <h5 className={"font-weight-bold"}>Vous avez choisi un mode de réglement par chéque</h5>
                        <p>Merci d'effectuer votre réglement au cordonnées suivantes </p>
                        <div className={"text-dark"}>
                            <table className={"table table-borderless text-left text-dark"}>
                                <tbody>
                                <tr><td width={150}>Adresse : </td><td className={"font-weight-bold"}>{(props.shop)?props.shop.name:''} {(props.shop)?props.shop.address:''}</td></tr>
                                <tr><td>Ordre du chéque  : </td><td className={"font-weight-bold"}>{(props.shop)?props.shop.name:''}</td></tr>
                                <tr><td>Référence de la commande : </td><td className={"font-weight-bold"}>{'uefr'+props.structure.id+moment().format('YYMMDHm')}</td></tr>
                                </tbody>
                            </table>
                        </div>
                        <p>Une fois l'encaissement effectué vos éléments seront disponibles dans votre espace</p>

                        <button className={"btn btn-primary"} onClick={handleCommande}>Commander</button>
                    </div>
                )
            case "carte":
                return (
                    (!commande)?
                    <div className={"text-center my-3"}>
                                <div className="form-check custom-control my-3">
                                    <input className="form-check-input custom-checkbox" type="checkbox" value={cgv}  id="cgv_check"
                                           onChange={(e)=>setCgv(e.target.checked)}
                                    />
                                        <label className="form-check-label" htmlFor="cgv_check">
                                            J'ai pris conaissance et j'accepte les conditions générales de vente
                                        </label>
                                </div>

                            <button className={"btn btn-primary my-2"} disabled={!cgv}  onClick={handleCommande}>Commander et payer</button>
                    </div>
                    :null
                )
        }
}

    return (
        <div className={"row"}>
            <div className="col">
                <h4 className={"font-weight-bold"}><span className={"badge badge-primary"}>3</span> Payement : </h4>
                <div className={"card"}>
                    <div className="card-body text-center">
                        {(!commande)?
                        <ToggleButtonGroup type="radio" variant={'secondary'} name={"pmod"} value={payMod} onChange={handleChange}>
                            {
                                payModValues.map(i=>{
                                    return <ToggleButton key={i.id}  value={i.code}><i className={i.picto}></i> {i.label}</ToggleButton>
                                })
                            }
                        </ToggleButtonGroup>
                        :null
                        }
                        {
                            (!payMod)?
                                <p className={"my-2"}>Merci de selectionner un mode de réglement</p>
                                :renderPAyMod()
                        }
                        {
                            (payMod=='carte' && cgv)?<PaymentProcess />:null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}




const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        products: state.ShopCartReducer.products,
        structure: state.SubscribtionReducer.structureInfo,
        tax: state.ShopCartReducer.tax,
        shop: state.ShopReducer.shop,
        orderAddress: state.CommandReducer.orderAddress,
    }
}


const mapDispatchTProps = dispatch => {
    return {
        emptyCart: (e) => dispatch( {type: 'EMPTY_CART'}),
        setPaymentIntent: (e) => dispatch({typr: 'SET_PAYMENT_INTENT', data:e})


    }
}

export default connect(mapStateToProps, mapDispatchTProps)(CommandePayementMethode);
